export const token_addresses = {
  customTokenAddress:"0x90cDc178eCaD7284de586DB08EeD86CC19F0D0C7",
  composerAddress:"0x754aeA031DDF06CEDa0CFFEfF52488c555613455",
  registryAddress:"0x0766c51503E26c48133F8C370646fF97F4AE1d9d"
}
